import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  :root { 
    --color-white: ${(props: any) => props.theme.COLOR.GREY.WHITE};
    --color-black: ${(props: any) => props.theme.COLOR.GREY.BLACK};
    --color-primary-100: ${(props: any) => props.theme.COLOR.PRIMARY?.['100']};
    --color-primary-200: ${(props: any) => props.theme.COLOR.PRIMARY?.['200']};
    --color-primary-300: ${(props: any) => props.theme.COLOR.PRIMARY?.['300']};
    --color-primary-400: ${(props: any) => props.theme.COLOR.PRIMARY?.['400']};
    --color-primary-500: ${(props: any) => props.theme.COLOR.PRIMARY?.['500']};
    --color-primary-600: ${(props: any) => props.theme.COLOR.PRIMARY?.['600']};
    --color-button-primary-background: var(--color-primary-500);
    --color-button-primary-background-hover: var(--color-primary-600);
    --color-button-primary-text: var(--color-white);
    --color-button-primary-text-hover: var(--color-white);
    --color-button-secondary-text: var(--color-primary-500);
    --color-button-secondary-border: var(--color-gray-300);
    --color-button-secondary-background: var(--color-gray-100);
    --color-button-secondary-text-hover: var(--color-primary-500);
    --color-button-secondary-background-hover: var(--color-gray-300);
  }

  body {
      padding-bottom: env(safe-area-inset-bottom);
      background-color: var(--color-white);
  }
`;
